import React, { useState } from "react";
import Phone from "./images/phone.svg";
import PropTypes from "prop-types";
import styles from "./styles.css";
import ArrowIcon from "../arrow";
import SemiModal from "../semi-modal";
import Button from "../button";
import PostInspectionDiyVideoSteps from "../post-inspection-diy-video-steps";

const PostInspectionDiyVideoStepsBanner = ({
    setHammerSwipeConnect
}) => {
    const [showSteps, setShowSteps] = useState(false);

    const handleToggle = (isEnabled) => {
        setHammerSwipeConnect(!isEnabled);
        setShowSteps(isEnabled);
    };

    if (showSteps) {
        return (<SemiModal>
            <div styleName={"styles.modalWrapper"}>
                <div styleName={"styles.videoStepsWrapper"}>
                    <PostInspectionDiyVideoSteps heading="See how it works!"/>
                </div>
                <div styleName={"styles.ctaWrapper"}>
                    <Button
                        text={"OK! GOT IT"}
                        onClick={() => handleToggle(false)}/>
                </div>
            </div>
        </SemiModal>
        );
    }

    return (
        <div styleName={"styles.confusedBanner"}>
            <img src={Phone} alt="phone" styleName={"styles.phoneImg"}/>
            <div styleName={"styles.confusedBannerText"}>
                <div>
                    <h2>Confused?</h2>
                    <p>See how it works!</p>
                </div>
                <div styleName={"styles.arrow"}>
                    <ArrowIcon white={"WhiteArrow"} rotateBy={-90} onClick={() => handleToggle(true)}/>
                </div>
            </div>
        </div>
    );
};

PostInspectionDiyVideoStepsBanner.propTypes = {
    setHammerSwipeConnect: PropTypes.func
};

export default PostInspectionDiyVideoStepsBanner;
